import { render } from "./JavaDoc.vue?vue&type=template&id=924ff5e8"
import script from "./JavaDoc.vue?vue&type=script&lang=js"
export * from "./JavaDoc.vue?vue&type=script&lang=js"

import "./JavaDoc.vue?vue&type=style&index=0&id=924ff5e8&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__